import LocationAndSchedule from './LocationAndSchedule';

export default LocationAndSchedule;